import { render, staticRenderFns } from "./AlertsCreate.vue?vue&type=template&id=e01e83a2&"
import script from "./AlertsCreate.vue?vue&type=script&lang=js&"
export * from "./AlertsCreate.vue?vue&type=script&lang=js&"
import style0 from "./AlertsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports